import { render, staticRenderFns } from "./table.vue?vue&type=template&id=6fc2d633&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=6fc2d633&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc2d633",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc2d633')) {
      api.createRecord('6fc2d633', component.options)
    } else {
      api.reload('6fc2d633', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=6fc2d633&scoped=true", function () {
      api.rerender('6fc2d633', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/table/table.vue"
export default component.exports